export const host = process.env.REACT_APP_HOST;
// export const host = "http://localhost:8080";
